module.exports = __webpack_public_path__ + "static/media/quill.b1425685.png";